import { createAction } from 'typesafe-actions';
import { Company } from '../types/management/Company';
import { EvalSubscriptionRequestType, SubscriptionType } from '../types/billing/SubscriptionType';

const show = createAction('changeSubscriptionActions/SHOW', resolve => (company: Company) => resolve({ company }));
const showEval = createAction('changeSubscriptionActions/SHOW_EVAL', resolve => (company: Company) => resolve({ company }));
const hide = createAction('changeSubscriptionActions/HIDE');
const setSubscriptionSavingFlag = createAction(
    'changeSubscriptionActions/SAVING_FLAG',
    resolve => (isSubscriptionSavingFlag: boolean) => resolve({ isSubscriptionSavingFlag }),
);
const saveSubscription = createAction(
    'changeSubscriptionActions/SAVE_SUBSCRIPTION',
    resolve => (companyId: number, subscriptionType: SubscriptionType | EvalSubscriptionRequestType, subscriptionExpiration?: Date, isTrial?: boolean) =>
        resolve({ companyId, subscriptionType, subscriptionExpiration, isTrial }),
);

export const changeSubscriptionActions = {
    show,
    showEval,
    hide,
    setSubscriptionSavingFlag,
    saveSubscription,
};
